/**
 * File system utilities for handling image uploads
 */

/**
 * Download file with specified filename without page navigation
 */
export const downloadFileWithName = (file, filename) => {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    
    // Add event listeners
    link.addEventListener('click', () => {
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        resolve();
      }, 100);
    });
    
    document.body.appendChild(link);
    link.click();
  });
};

/**
 * Trigger download and return filename for database storage
 */
export const saveImageToLocalFolder = async (file, filename) => {
  try {
    // Wait for download to complete
    await downloadFileWithName(file, filename);
    
    console.log(`📁 Downloaded: ${filename}`);
    console.log(`📂 Place in: /public/images/props/`);
    
    return {
      filename,
      success: true
    };
    
  } catch (error) {
    throw error;
  }
};

/**
 * Create properly formatted filename for prop images
 */
export const generateImageFilename = (propId, originalFilename, index = 0) => {
  const extension = originalFilename.split('.').pop().toLowerCase();
  const timestamp = Date.now();
  const suffix = index === 0 ? 'main' : `img${index}`;
  
  return `${propId}_${suffix}_${timestamp}.${extension}`;
};

/**
 * Validate image file
 */
export const validateImageFile = (file) => {
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  const maxSize = 5 * 1024 * 1024; // 5MB
  
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please use JPG, PNG, GIF, or WebP');
  }
  
  if (file.size > maxSize) {
    throw new Error('File too large. Maximum size is 5MB');
  }
  
  return true;
};
